import { RefObject } from 'react'

import useEventListener from './useEventListener'

type Handler = (event: MouseEvent) => void
const CLICK_OUTSIDE_SAFE_KEY = 'data-click-outside-safe'
/**
 * Give an element this constant to overrule click outside
 * @example {...data_click_outside_safe}
 * */
export const data_click_outside_safe = { [CLICK_OUTSIDE_SAFE_KEY]: true }

function useOnClickOutside<T extends HTMLElement = HTMLElement>(
    ref: RefObject<T>,
    handler: Handler,
    mouseEvent: 'mousedown' | 'mouseup' = 'mousedown',
): void {
    useEventListener(mouseEvent, (event) => {
        const el = ref?.current

        const target = event.target as Element

        if (target.hasAttribute(CLICK_OUTSIDE_SAFE_KEY)) return

        // Do nothing if clicking ref's element or descendent elements or svg
        // svg >>> Clicks on an svg are seen as a click on window and therefore always outside the element. Clicking on a "clear" cross from a select closes the modal it is in...
        if (!el || el.contains(target) || ['svg', 'path', 'circle', 'rect', 'g'].includes(target.nodeName)) {
            return
        }

        handler(event)
    })
}

export default useOnClickOutside
